import React__default from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("InteractiveTags", {
  root: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--zds-space-8);
  `
});
const InteractiveTags = (props) => {
  const tags = React__default.Children.toArray(props.children).filter(Boolean).map((child, i) => {
    return jsx("li", { key: i }, child);
  });
  return jsx("ul", { "aria-label": props["aria-label"], css: Styles.root, "data-zds": true }, tags);
};

export { InteractiveTags };
//# sourceMappingURL=InteractiveTags.es.js.map
